<template>
  <v-row>
    <v-col md="3" cols="12">
      <v-text-field
        v-if="searchField"
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        hide-details="auto"
        label="Search"
        outlined
        dense
        @input="$emit('updateSearch', search)"
      ></v-text-field>
    </v-col>

    <v-col md="2" cols="12" v-if="showProgramFilter">
      <v-select
        v-model="programSchemeFilter.program"
        hide-details="auto"
        :items="programs"
        label="Programme"
        :item-text="
          (program) =>
            `${program.degree?.short_name || ''}  ${
              program.specialization ? ' - ' : ''
            } ${program.specialization || ''}`
        "
        :item-value="
          (program) =>
            `${program.degree?.short_name || ''}  ${
              program.specialization ? ' - ' : ''
            } ${program.specialization || ''}`
        "
        outlined
        clearable
        dense
        @input="$emit('updateProgram', programSchemeFilter.program)"
      ></v-select>
    </v-col>
    <v-col md="2" cols="12" v-if="showBatchFilter">
      <v-select
        v-model="filterBatch"
        hide-details="auto"
        :items="batches"
        label="Year"
        outlined
        dense
        clearable
        @input="$emit('batchFilter', filterBatch)"
      ></v-select>
    </v-col>
    <v-col md="2" cols="12" v-if="showFilter">
      <v-text-field
        v-model="filterYear"
        hide-details="auto"
        label="Year"
        outlined
        dense
        clearable
        :rules="[rules.yearValidation]"
        @input="$emit('updateYear', filterYear)"
      ></v-text-field>
    </v-col>
    <v-col md="2" cols="12" v-if="showFilter">
      <v-select
        v-model="filterBatch"
        hide-details="auto"
        :items="['1', '2']"
        label="Batch"
        outlined
        clearable
        dense
        @input="$emit('updateBatch', filterBatch)"
      ></v-select>
    </v-col>

    <v-spacer></v-spacer>
    <v-col md="3" cols="3" class="d-flex justify-end px-0">
      <v-btn
        v-if="showOrderBtn"
        @click="$emit('saveOrder')"
        class="primary mr-3"
      >
        Save Changes
      </v-btn>
      <v-btn
        v-if="uploadButton"
        class="primary mr-3"
        @click="$emit('help')"
        icon
      >
        <v-icon color="secondary">mdi-information-variant</v-icon>
      </v-btn>
      <v-btn v-if="uploadCsvButton" color="primary" @click="$emit('uploadButton')" class="mr-2">
          <v-icon left>mdi-upload</v-icon>
          Upload
        </v-btn>
      <v-btn v-if="downloadButton" class="primary mr-3" @click="download">
        Download
      </v-btn>
      <v-btn
        v-if="uploadButton"
        @click="dialog = true"
        class="primary mr-3"
        :loading="loading"
      >
        Upload
      </v-btn>
      <v-btn
        v-if="addField"
        @click="$emit('add')"
        :disabled="disableAdd"
        class="primary ml-2 mr-3"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="font-weight-medium secondary--text primary">
          Upload {{ headerText }}
          <v-spacer></v-spacer>
          <v-btn small icon @click="cancel">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5">
          <v-row>
            <v-col cols="12">
              <v-file-input
                v-model="selectedFile"
                outlined
                dense
                accept=".csv"
                hide-details="auto"
                prepend-inner-icon="mdi-file-upload"
                prepend-icon=""
                label="Upload CSV"
              >
                <template v-slot:selection="{ text }">
                  <span
                    class="text-body-2 text-truncate"
                    style="max-width: 100%"
                  >
                    {{ selectedFile ? selectedFile.name : text }}
                  </span>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0 mx-2">
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="save"> Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { rules } from "@/helpers/rules";
export default {
  props: {
    searchField: {
      type: Boolean,
      default: true,
    },
    addField: {
      type: Boolean,
      default: true,
    },
    uploadButton: {
      type: Boolean,
      default: false,
    },
    downloadButton: {
      type: Boolean,
      default: false,
    },
    headerText: {
      type: String,
      default: "",
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    downloadUrl: {
      type: String,
      default: "",
    },
    showFilter: {
      type: Boolean,
      default: false,
    },
    showProgramFilter: {
      type: Boolean,
      default: false,
    },
    programs: {
      type: Array,
      default: () => [],
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
    showOrderBtn: {
      type: Boolean,
      default: false,
    },
    showBatchFilter: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: 0,
    },
    parentName: {
      type: String,
      default: "",
    },
    uploadCsvButton: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      rules,
      search: "",
      filterYear: "",
      filterBatch: "",
      dialog: false,
      selectedFile: null,
      loading: false,
      programSchemeFilter: {},
      batchSchemes: [],
      batchFilter: {},
      batches: [],
    };
  },
  created() {
    if (this.showProgramFilter) {
      this.getBatches();
    }
    if (this.showBatchFilter) this.generateBatches();
  },
  methods: {
    async getBatches() {
      const { data } = await this.$axios.get("batch_schemes");
      this.batchSchemes = data.data;
    },
    getBatchName(batch) {
      return `${batch.year}-${batch.batch}`;
    },
    cancel() {
      this.dialog = false;
      this.selectedFile = null;
    },
    async generateBatches() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      this.loading = true;
      const formData = new FormData();

      formData.append("csv_file", this.selectedFile, this.selectedFilename);
      if (this.parentName) formData.append(this.parentName, this.parentId);
      await this.$axios
        .post(`${this.uploadUrl}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.loading = false;
          if (response.status === 201) {
            this.$emit("error", response.data);
            this.selectedFile = null;
            this.dialog = false;
            return;
          }

          this.$store.commit("showSnackbar", {
            message: "Uploaded Successfully",
            color: "success",
          });
          this.selectedFile = null;
          this.dialog = false;
          this.$emit("uploaded");
        })
        .catch(async (error) => {
          this.loading = false;
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          if (errorMessage == "Uploaded csv has invalid headers")
            this.selectedFile = null;
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async download() {
      this.$axios
        .get(this.downloadUrl, {
          params: { ...this.form },
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.headerText}.csv`);
          document.body.appendChild(link);
          link.click();
        });
    },
  },
};
</script>
